module.exports = __webpack_public_path__ + "img/magic-guide.e741ce31.webp";